import {FormEvent,useEffect} from "react";
import {useMutation,useQueryClient} from "@tanstack/react-query";
import {useNavigate} from "react-router-dom";
import {api,json} from "../api";
import {useLocale,useSession} from "../App";
import entryEn433Avif from "../assets/entry-en-433.avif";
import entryEn866Avif from "../assets/entry-en-866.avif";
import entryEn433Webp from "../assets/entry-en-433.webp";
import entryEn866Webp from "../assets/entry-en-866.webp";
import entryVn433Avif from "../assets/entry-vn-433.avif";
import entryVn866Avif from "../assets/entry-vn-866.avif";
import entryVn433Webp from "../assets/entry-vn-433.webp";
import entryVn866Webp from "../assets/entry-vn-866.webp";
const entryVisuals={
  en:{avif:[entryEn433Avif,entryEn866Avif],webp:[entryEn433Webp,entryEn866Webp]},
  vn:{avif:[entryVn433Avif,entryVn866Avif],webp:[entryVn433Webp,entryVn866Webp]},
} as const;

export function EntryPage(){
  const lang=useLocale();const navigate=useNavigate();const queryClient=useQueryClient();const session=useSession();
  const visual=entryVisuals[lang==="vn"?"vn":"en"];
  const firstDestination=lang==="vn"?`/${lang}/welcome`:`/${lang}/nearby`;
  useEffect(()=>{if(session.data?.user)navigate(firstDestination,{replace:true});},[session.data?.user,firstDestination,navigate]);
  const create=useMutation({mutationFn:(name:string)=>api("/session",json("POST",{name})),onSuccess:async()=>{await queryClient.invalidateQueries({queryKey:["session"]});navigate(firstDestination);}});
  const submit=(event:FormEvent<HTMLFormElement>)=>{event.preventDefault();const name=String(new FormData(event.currentTarget).get("displayName")??"").trim();if(name)create.mutate(name);};
  return <main className="entry-page" data-lang={lang}>
    <picture className="entry-picture" aria-hidden="true">
      <source type="image/avif" srcSet={`${visual.avif[0]} 433w, ${visual.avif[1]} 866w`} sizes="min(100vw, 433px)"/>
      <img className="entry-visual" src={visual.webp[1]} srcSet={`${visual.webp[0]} 433w, ${visual.webp[1]} 866w`} sizes="min(100vw, 433px)" width="866" height="1817" alt="" fetchPriority="high" decoding="async" draggable={false}/>
    </picture>
    <form onSubmit={submit}>
      <input name="displayName" aria-label={lang==="vn"?"Nhập tên của bạn":"Enter your name"} placeholder={lang==="vn"?"Nhập tên của bạn":"Enter your name"} defaultValue="" required maxLength={40} autoComplete="name" inputMode="text" enterKeyHint="go"/>
      <button type="submit" aria-label={lang==="vn"?"Bắt đầu kết nối gần bạn":"Start Matching Nearby"} disabled={create.isPending}/>
    </form>
    {create.isError&&<p className="entry-error">{lang==="vn"?"Hiện chưa thể bắt đầu. Vui lòng thử lại.":"Couldn't start right now. Please try again."}</p>}
  </main>;
}
